interface LoadingIndicatorProps {
    [key: string]: any;
}

export function LoadingIndicator(props: LoadingIndicatorProps): any {
    return (
        <div className="mb-3 flex justify-center">
            <div className="flex gap-3 p-3 rounded-lg border border-gray-300" style={{ width: '527px', backgroundColor: '#F1F5F9' }}>
                <div className="flex-1">
                    <div className="flex items-center gap-1">
                        <span className="text-gray-600">Thinking</span>
                        <div className="flex gap-1">
                            <div className="w-1 h-1 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                            <div className="w-1 h-1 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                            <div className="w-1 h-1 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
